export const THEME_STORAGE_KEY = "theme";

export type ThemeMode = "light" | "dark";

// Resolve the initial theme mode using the same precedence the pre-React inline script in
// index.html uses: persisted choice -> light.  Keep these in sync.
export function resolveInitialThemeMode(): ThemeMode {
    try {
        const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
        if (stored === "light" || stored === "dark") return stored;
    } catch { }

    return "light";
}
